<template>
    <div class="m-steps">
        <div class="box-content">
            <div class="box-item" v-for="(item, index) in stepList" :key="index">
                <div class="flag flag-left" v-if="index"></div>
                <div class="center-box" :class="{'has':index +1 < active,'current': index+1 === active}">
                    <template v-if="index+1 > active || index + 1 == active">
                        <i class="el-icon-error" v-if="thisStep == 3.3 && index == stepList.length -1"></i>
                        <div class="step-index step-num" v-else>{{index + 1 }}</div>
                        
                    </template>
                    <i class="el-icon-success" v-else></i>
                    <div class="step-text" :class="{'red-font': thisStep == 3.3 && index == stepList.length -1}">{{ getText(item, index, stepList.length) }}</div>
                </div>
                <div class="flag flag-right" v-if="index !== (stepList.length - 1)"></div>
            </div>
        </div>
    </div>
</template>

<script>
import * as access from "@/config/access";

export default {
    props: {
        active: {
            type: Number,
            default: 0
        },
        stepList: {
            type: Array,
            default: ()=>{
                return []
            }
        },
        thisStep: {
            type: Number,
            default: 0
        }
    },
    
    data(){
        return {
            checkStatus: access.session('checkStatus') || '',
        }
    },
    methods: {
        getText(text, index, len){
            let vm = this;
            if(index != len - 1) return text;
            return vm.thisStep == 3.2 ? '审核通过' : vm.thisStep == 3.3 ? '审核不通过' : text
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../style/variable';
    .m-steps{
        border-radius: 4px;
        background-color: $c1;
        margin-bottom: 20px;
        .box-content{
            padding: 60px 0;
            text-align: center;
            .box-item{
                position: relative;
                display: inline-block;
                width: 200px;
                font-size: $fs_14;
                color: $c16;
                .flag{
                    position: absolute;
                    width: 60px;
                    height: 1px;
                    background-color: $c17;
                    top:16px;
                }
                .flag-left{
                    top: 16px;
                }
                .flag-right{
                    right: 0;
                }
                .center-box{
                    >i{
                        display: inline-block;
                        font-size: $fs_40;
                        &.el-icon-success{
                            color: $c18;
                        }
                        &.el-icon-error{
                            color: $c20;
                        }
                    }
                    .step-num{
                        width: 40px;
                        height: 40px;
                        margin: 0 auto;
                        line-height: 40px;
                        color: $c16;
                        font-size: $fs_16;
                        border-radius: 50%;
                        background-color: $c19;
                    }
                    &.has{
                        .step-index{
                            display: none;
                        }
                        .step-text{
                            color: $c18;
                            &.red-font{
                                color: $c20;
                            }
                        }
                    }
                    &.current{
                        .step-num{
                            color: $c1;
                            // background-color: $c4;
                            background-color: $c4;

                        }
                        .step-text{
                            color: $c4;
                        }
                    }
                    
                    .el-icon-check{
                        display: none;
                    }
                    text-align: center;
                }
            }
        }
    }
</style>